
import { GenericRecord, RavRecord } from '#record/model';
import { Vid } from '#vid/model';
import { useCall } from 'apprise-frontend-core/client/call';
import { usePreload } from 'apprise-frontend-core/client/preload';
import addDays from 'date-fns/addDays';
import { Submission, SubmissionRef } from './model';
import { ValidationReport } from './validator';
import { useAppSettings } from '#settings/settings';
import { useOracle } from 'apprise-frontend-iam/authz/oracle';


export const submissionApi = '/submission'


export const useSubmissionCalls = () => {

    const call = useCall()

    const preload = usePreload()

    const oracle = useOracle()
    const { submissionAgeCutoff = 0, submissionAgeCutoffTenant = 0 } = useAppSettings()
    const ageCutoff = oracle.isCrossTenant() ? submissionAgeCutoff : submissionAgeCutoffTenant
    const cutoff = addDays(Date.now(), -ageCutoff);

    const self = {

        fetchAll: (useCutoff: boolean) => {

            const endpoint = ageCutoff && useCutoff ? `${submissionApi}?cutoff=${cutoff.toISOString()}` : submissionApi

            // we join preload only if there's no cutoff, otherwise we load basd on the cuttof non the static preload
            return ageCutoff ? call.at(endpoint).get<Submission[]>() : preload.get<Submission[]>(submissionApi) ?? call.at(submissionApi).get<Submission[]>()
        }

        ,

        fetchOne: (submission: SubmissionRef) => call.at(`${submissionApi}/${submission}`).get<Submission>()

        ,

        add: (submission: Submission) => call.at(submissionApi).post<Submission>(submission)

        ,

        update: (submission: Submission) => call.at(`${submissionApi}/${submission.id}`).put<Submission>(submission)

        ,

        remove: (id: string) => call.at(`${submissionApi}/${id}`).delete()

        ,


        validate: <T extends GenericRecord>(submission: Submission<T>) => call.at(`${submissionApi}/validate`).post<ValidationReport>(submission)

        ,

        match: <T extends GenericRecord>(submission: Submission<T>) => call.at(`${submissionApi}/match`).post<Record<Vid, RavRecord[]>>(submission)


    }


    return self;
}